'use client';
import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeSubscriptionRecord } from '../types';

type SubscriptionsParams = {
  userUuid: string;
  fetchPrepaidStatuses?: boolean;
};

export default function useSubscriptions(params: SubscriptionsParams) {
  const { userUuid, fetchPrepaidStatuses } = params;
  const queryParams = new URLSearchParams();

  if (fetchPrepaidStatuses) {
    queryParams.append(
      'fetch_prepaid_statuses',
      fetchPrepaidStatuses.toString(),
    );
  }

  const subscriptionsUri = `${
    API_URLS.SUBSCRIPTION_MANAGER
  }recipient/${userUuid}/subscriptions${queryParams ? `?${queryParams}` : ''}`;

  const {
    data: subscriptionsData,
    isLoading: isLoadingSubscriptions,
    error: subscriptionsError,
    mutate: mutateSubscriptions,
  } = useSWR<TypeSubscriptionRecord[], Error>(
    subscriptionsUri,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data: subscriptionsData,
    loading: isLoadingSubscriptions,
    error: subscriptionsError,
    mutate: mutateSubscriptions,
  };
}
